<script>
import Videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-flash";
import "vue-video-player/src/custom-theme.css";
import "videojs-flvjs";
window.videojs = Videojs;
require("../../../../node_modules/video.js/dist/lang/zh-CN.js");

import { formatDate } from "@/utils/filters";

import { getLivingTime, getLivingTimeApi } from "@/api/partyTop";

export default {
  data() {
    return {
      privacyText:
        "【隐私说明】为提供直播、智能监控等服务，本软件需调用摄像头。采集内容仅用于当前功能，数据传输加密处理，您可随时在系统设置中关闭权限。我们始终重视您的隐私安全。",
      village: localStorage.getItem("currentCommunity") || "",
      liveTheme: "",
      liveArea: "",
      liveTitle: "",
      livingPlayer: null,
      livingUrl: "",
      startTime: "", // new Date('2023/06/13 15:18:00').getTime() / 1000 + ' ', // 直播开始时间
      endTime: "", // new Date('2023/06/13 15:18:20').getTime() / 1000 + ' ', // 直播结束时间
      options: {
        language: "zh-CN",
        autoplay: true,
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        controls: true,
        loop: true,
        notSupportedMessage: "直播重连中，请稍后再试！",
      },
      playerType: "application/x-mpegURL", // video/mp4
      /* countdown */
      days: "1",
      hours: "",
      minutes: "",
      seconds: "",
      isStart: false,
      isEnd: false,
      livingInfo: {},
      isError: false,
    };
  },
  computed: {
    livingIsEnd() {
      const compareTime = new Date(this.endTime).getTime() / 1000 + " ";
      const nowTime = new Date();
      const endTime = new Date(compareTime * 1000);
      const t = endTime.getTime() - nowTime.getTime();
      return t;
    },
    livingState() {
      const { isStart, isEnd } = this;
      return { isStart, isEnd };
    },
  },
  watch: {
    seconds(newVal) {
      this.isStart =
        this.days == 0 &&
        Number(this.hours) == 0 &&
        Number(this.minutes) == 0 &&
        Number(newVal) == 0;
      if (this.isStart && !this.isEnd) this.getVideo(this.livingUrl);
    },
    livingState: {
      handler(val) {
        const { isStart, isEnd } = val;
        if (isStart && !isEnd) this.getVideo(this.livingUrl);
        // if (isEnd && this.livingPlayer) this.livingPlayer.dispose()
        if (isEnd && this.livingPlayer) {
          this.livingPlayer.dispose();
          this.livingPlayer = null;
        }
      },
      immediate: true,
      deep: true,
    },
    startTime() {
      this.countdown(this.startTime);
    },
  },
  created() {
    this.getLivingInfo();
  },
  beforeDestroy() {
    if (this.livingPlayer) this.livingPlayer.dispose();
    this.getLivingTimeReq(0);
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    getLivingTimeReq(state) {
      const params = {
        state,
        liveid: this.livingInfo?.id || 0,
        village: this.village,
      };
      getLivingTimeApi(params);
    },
    getVideo(nowPlayVideoUrl) {
      setTimeout(() => {
        this.livingPlayer = Videojs("livingVideoPlayer", this.options);
        this.livingPlayer.src([
          { src: nowPlayVideoUrl, type: this.playerType },
        ]);

        // 监听错误事件，自定义错误处理
        this.livingPlayer.on("error", () => {
          const error = this.livingPlayer.error();
          if (error) {
            console.log(error.message);
            error.message = "直播加载错误，调试中请稍后！";
            // 隐藏默认错误提示
            const errorDisplay = this.livingPlayer.getChild("errorDisplay");
            if (errorDisplay) {
              // errorDisplay.hide();
            }
            this.isError = true;
            this.isStart = false;
          }
        });
      }, 200);
    },
    getLivingInfo() {
      getLivingTime().then((res) => {
        const { code, msg } = res;
        this.livingInfo = code === 0 ? msg || {} : {};
        if (code === 0) {
          const { liveUrl, startTime, endTime, liveMemo } = msg;
          const [liveTheme, liveArea, liveTitle] = liveMemo.split(",");
          this.liveTheme = liveTheme || "";
          this.liveArea = liveArea || "";
          this.liveTitle = liveTitle || "";
          this.livingUrl = liveUrl || "";
          // if (this.livingUrl) this.getVideo(this.livingUrl)
          const startTimeFormat = formatDate(
            startTime,
            "yyyy-MM-dd hh:mm:ss"
          ).replace(/-/g, "/");
          const endTimeFormat = formatDate(
            endTime,
            "yyyy-MM-dd hh:mm:ss"
          ).replace(/-/g, "/");
          this.startTime = new Date(startTimeFormat).getTime() / 1000 + " "; // 直播开始时间
          this.endTime = new Date(endTimeFormat).getTime() / 1000 + " "; // 直播结束时间
          this.countdown(this.startTime);
          this.monitorLivingEnd(this.endTime);
          this.getLivingTimeReq(1);
        }
      });
    },
    countdown(timestamp) {
      const self = this;
      const timer = setInterval(function () {
        const nowTime = new Date();
        const endTime = new Date(timestamp * 1000);
        const t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          const day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;

          self.days = day;
          self.hours = hour;
          self.minutes = min;
          self.seconds = sec;
        } else {
          clearInterval(timer);
          self.days = "0";
          self.hours = "00";
          self.minutes = "00";
          self.seconds = "00";
        }
      }, 1000);
    },
    monitorLivingEnd(timestamp) {
      const self = this;
      const timer2 = setInterval(function () {
        const nowTime = new Date();
        const endTime = new Date(timestamp * 1000);
        const t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          self.isEnd = false;
        } else {
          clearInterval(timer2);
          self.isEnd = true;
        }
      }, 1000);
    },
  },
};
</script>

<template>
  <div class="congress20 congress20-living">
    <el-tooltip
      class="item"
      effect="dark"
      :content="privacyText"
      placement="left"
    >
      <p class="privacy_text">隐私</p>
    </el-tooltip>

    <el-image :src="require('imgs/partyTop/page-bg.webp')" class="page-bg" />
    <!-- <div>
      <div class="page-container-countdown">
        <div class="living-text">正在直播</div>
      </div>
    </div> -->
    <div class="page-title-box">
      <div class="live-text-fir">
        <el-image
          :src="require('imgs/partyTop/live-logo.webp')"
          class="live-logo"
        />
        <div>
          <p :text="liveTheme" class="live-text">
            {{ liveTheme }}
          </p>
          <p :text="liveArea" class="live-text">
            {{ liveArea }}
          </p>
        </div>
      </div>

      <p :text="liveTitle" class="live-text">
        {{ liveTitle }}
      </p>
    </div>
    <div class="video-container">
      <div v-if="isStart && !isEnd && !isError" class="video-box">
        <video
          id="livingVideoPlayer"
          ref="livingVideoPlayer"
          class="video-js"
          preload="none"
          webkit-playsinline=""
          x-webkit-airplay="allow"
          playsInline=""
          x5-playsinline=""
          x5-video-orientation="portraint"
        />
      </div>
      <div v-if="!isStart && !isEnd && !isError" class="tip-container">
        <p class="t1">直播暂未开始</p>
        <p class="t2">敬请期待</p>
      </div>
      <div v-if="isEnd" class="tip-container">
        <p class="t1">直播已结束</p>
        <p class="t2">感谢您的观看</p>
      </div>
      <div v-if="isError" class="tip-container">
        <p class="t1">直播加载错误</p>
        <p class="t2">正在调试中，请稍后</p>
      </div>
    </div>
    <img
      v-if="isStart && !isEnd"
      class="foot-img"
      :src="require('imgs/partyTop/foot.png')"
      fit="cover"
    />
    <img
      class="return-img"
      :src="require('imgs/partyTop/party-building/return.png')"
      fit="return"
      @click="onBack"
    />
  </div>
</template>

<style lang="scss">
.congress20-living {
  .video-js .vjs-modal-dialog {
    border-radius: 20px;
  }
  .video-js {
    .vjs-big-play-button {
      width: 50px;
      height: 30px;
      font-size: 20px;
      text-align: center;
      top: 48% !important;
      left: 45% !important;
    }
  }
  .video-js .vjs-tech {
    border-radius: 8px;
  }
}
</style>
<style lang="scss" scoped>
.congress20 {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .privacy_text {
    position: absolute;
    right: 8px;
    bottom: 40px;
    font-size: 16px;
    color: #f98b6f;
    cursor: pointer;
  }
  .page-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -2;
    width: 100%;
    height: 100%;
  }
  .page-title-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 1400px;
    max-width: calc(100% - 50px);
    min-height: 200px;
    padding: 0 166px 0 140px;
    box-sizing: border-box;
    // padding: 0 0 0 100px;
    background: url("~imgs/partyTop/live-line.webp") no-repeat;
    background-position: bottom right;
    background-size: 270px 165px;
    // background: url('~imgs/partyTop/live-title-bg.webp') no-repeat;
    // background-position: top right;
    // background-size: 1260px 172px;
    margin-top: 45px;
    .live-text {
      width: 100%;
      position: relative;
      font-size: 74px;
      font-weight: bold;
      font-style: italic;
      padding-right: 10px;
      background-image: linear-gradient(
        268deg,
        #fff08a 1%,
        #fffedf 36%,
        #fff08a 63%,
        #fffedf 100%
      );
      text-align: right;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .live-text-fir {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 60px;
      .live-logo {
        width: 164px;
        height: 98px;
      }
    }
    .live-title {
      position: relative;
      font-size: 74px;
    }
    .live-text::before {
      content: attr(text);
      position: absolute;
      right: 7px;
      z-index: -1;
      text-shadow: 0px 5px 3px rgba(108, 7, 0, 0.66);
    }
  }
  .return-img {
    position: absolute;
    width: 132px;
    height: 52px;
    bottom: 0;
    left: 894px;
    cursor: pointer;
  }
}
.page-container-countdown {
  width: 1200px;
  display: flex;
  justify-content: flex-start;
  margin-top: 130px;
}
.video-js {
  border-radius: 10px;
}
.video-container {
  width: 1200px;
  height: 675px;
  border-radius: 10px;
  border: 3px solid #ffeed4;
  box-sizing: border-box;
  margin-top: 50px;
  .tip-container {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(#000, #353333, #353333, #353333, #000);
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    .t1,
    .t2 {
      padding: 0;
      margin: 0;
    }
    .t1 {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
    }
    .t2 {
      font-size: 22px;
      color: #fff;
      margin-top: 10px;
    }
  }
}
.video-box {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
#livingVideoPlayer {
  width: 100%;
  height: 100%;
}
.foot-img {
  width: 115px;
  height: 14px;
}

.custom-error-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 30px 40px;
  border-radius: 8px;
  z-index: 999999;
  .error-content {
    text-align: center;
    color: #fff;
    .error-message {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .error-tip {
      font-size: 16px;
      opacity: 0.8;
    }
  }
}

.living-text {
  width: 133px;
  height: 33px;
  background: #e43104;
  border: 1px solid #fff5aa;
  border-radius: 4px;
  display: grid;
  place-items: center;
  margin-top: 15px;

  font-size: 13px;
  font-weight: bold;
  color: #fef1a7;
}
</style>
